import Heading from "components/Heading";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import {
  Button, Col, Container, Row, Table, UncontrolledDropdown,
  DropdownToggle, DropdownMenu, DropdownItem,
  Alert,
  Card
} from "reactstrap";
import { errorHandler, toLocaleTime } from "utils/Api";
import styles from "./style.module.scss";
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import { deletePackage, getBoxesByPoBox, getPackages, savePackage } from "api/PackagesApi";
import LoadingTBody from "components/LoadingTBody";
import { MOVEMENT_STATUS } from "utils/Constants";
import { showAlert } from "utils/Alert";
import DeleteModal from "components/DeleteModal";
import AddWarehouseModal from "components/AddWarehouseModal";
import PackageCostDetails from "components/OffCanvas/PackageCostDetailsOffCanvas";
import { useAmplifyIncrementalList } from "utils/hooks/useAmplifyIncrementalList";
import { debounce } from "lodash";
import DynamicForm from "components/DynamicForm";
import POBoxDetails from "components/POBoxDetails";
import PackageAdviseNoticeOffCanvas from "components/OffCanvas/PackageAdviseNoticeOffCanvas";
import { getPoBox } from "api/POBoxApi";
import { getPackageStatus, toNumberFormat } from "utils/Utils";
import ConfirmModal from "components/ConfirmModal";

const PAGE_SIZE_LIMIT = 100

const PackagesByPoBox = props => {
  let navigate = useNavigate();
  let { poBoxId } = useParams();
  const [poBox, setPoBox] = useState({});
  const [typeAheadFilter, setTypeAheadFilter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [isDeliveryConfirmVisible, setDeliveryConfirmVisible] = useState(false);
  const [toUpdateBox, setToUpdateBox] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(true);

  const buildPackagesFilter = (filter) => {
    const q = (filter || "").trim();
    if (!q) return null;

    return {
      or: [
        { secuencia: { contains: q } },
        { tracking_num: { contains: q } },
        { warehouseNumber: { eq: q } },
      ],
    };
  };

  const fetchPackages = async ({
    limit,
    nextToken,
    filter,
    sortDirection
  }) => {
    return await getBoxesByPoBox(
      {
        poBoxId,
        limit,
        nextToken,
        filter,
        sortDirection,
      }
    )
  }

  const {
    items: boxesList,
    isLoadingInitial,
    isLoadingMore,
    isSearching,
    reload: reloadView,
    bottomRef,
  } = useAmplifyIncrementalList({
    fetchPage: fetchPackages,
    searchText: typeAheadFilter,
    buildFilter: buildPackagesFilter,
    pageSize: PAGE_SIZE_LIMIT,
  });

  const showLoading = isLoadingInitial || isLoadingMore || isSearching || isLoading;

  useEffect(() => {
    if (poBoxId) {
      fetchPOBox()
    }
  }, [poBoxId])

  const fetchPOBox = async () => {
    getPoBox(poBoxId).then((r) => {
      setPoBox(r);
    }).catch((e) => {
      errorHandler(e)
    }).finally((e) => setIsLoading(false));
  }

  const renderPackageCommotity = (box) => {
    debugger
    try {
      const commotity = JSON.parse(box.commotity);
      return commotity.map(r => {
        return (
          <tr>
            <td>
              {r.cant}
            </td>
            <td>
              {r.description}
            </td>
            <td>
              $ {toNumberFormat(r.price)}
            </td>
          </tr>
        )
      })

    } catch (err) {
      errorHandler(err, "Carga Detalle de paquete")

    }
    return ""
  }

  const renderList = () => {
    return boxesList.map((box) => {
      let created = toLocaleTime(box.createdAt);
      return (
        <>
          <tr key={box.id} className={styles.featureRowData}>
            <td>
              <b>{box.secuencia}</b>
            </td>
            <td>
              {box.warehouseNumber}
            </td>
            <td>
              {box.client}
            </td>
            <td>
              {created}
            </td>
            <td>
              {box.cargoMovement && box.cargoMovement.secuencia}
            </td>
            <td>
              {getPackageStatus(box)}
            </td>
            <td>
              <PackageCostDetails box={box} color="primary" />
            </td>
            <td>
              {rowActions(box)}
            </td>
          </tr>
          <tr key={`${box.id}-details`}>
            <td colSpan={20}>
              <Card className="p-3">
                <Row>
                  <Col>
                    <h5>Contenido de Paquete (commotity)</h5>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Table>
                      <thead>
                        <tr>
                          <th>
                            Cant
                          </th>
                          <th>
                            Descripcion
                          </th>
                          <th>
                            Precio
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderPackageCommotity(box)}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Alert color="primary">
                      Monto Reportado: <b>${toNumberFormat(box.cost)}</b>
                    </Alert>
                  </Col>
                </Row>
              </Card>
            </td>
          </tr>
        </>
      );
    });
  }

  const deleteBox = (box) => {
    setIsLoading(true);
    deletePackage(box)
      .then(async (r) => {
        showAlert("success", `El Paquete #${box.secuencia} fue eliminado correctamente`);
        toogleModal();
      }).catch(e => {
        errorHandler(e);
        showAlert("danger", `No fue posible eliminar el paquete #${box.secuencia}`);
      })
      .finally(() => {
        setIsLoading(false);
        reloadView()
      });
  }

  const showDeleteConfirm = (box) => {
    setDeleteConfirmVisible(true)
    setToUpdateBox(box);
    setIsModalOpen(true);
  }

  const showDeliveryConfirm = (box) => {
    setDeliveryConfirmVisible(true)
    setToUpdateBox(box);
    setIsModalOpen(true);
  }

  const toogleModal = (e) => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      setToUpdateBox({});
      setDeliveryConfirmVisible(false)
      setDeleteConfirmVisible(false)
    }
  }

  const rowActions = (box) => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className={styles.threedotsBtn} >
          <ThreeDotsVertical size="1.5rem" />
        </DropdownToggle>
        <DropdownMenu container="body">
          <DropdownItem header>
            Acciones
          </DropdownItem>
          <DropdownItem onClick={(e) => { navigate(`/admin/package/edit/${box.id}`) }}>
            Editar Paquete
          </DropdownItem>
          <DropdownItem onClick={(e) => { navigate(`/admin/package/cost/${box.id}`) }}>
            Editar Costo de Paquete
          </DropdownItem>
          {box.cargoMovement && box.cargoMovement.id && (
            <DropdownItem onClick={(e) => { navigate(`/admin/cargo-movement/edit/${box.cargoMovement.id}`) }}>
              Editar Movimiento de Carga
            </DropdownItem>
          )}
          <DropdownItem onClick={(e) => showDeleteConfirm(box)}>
            Eliminar Paquete
          </DropdownItem>
          {!box.isDelivered && (
            <DropdownItem onClick={(e) => showDeliveryConfirm(box)}>
              Marcar Paquete Como Entregado
            </DropdownItem>
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  const getSearchForm = () => {
    return {
      sections: [{
        fields: [
          [
            {
              "type": "text",
              "name": "q",
              "label": "Filtro",
              "disabled": false,
              "sizing": {
                "sm": 6
              }
            },
          ]
        ]
      }]
    };
  }

  const typeAHeadSearch = debounce((search) => {
    setTypeAheadFilter(search);
  }, 500)

  const onDeliveryConfirmed = async () => {
    const boxData = {
      id: toUpdateBox.id,
      isDelivered: true,
    }
    try {
      setIsLoading(true)
      debugger
      await savePackage(boxData);
      showAlert("success", "El paquete ha sido marcado como Entregado")
      reloadView()
    } catch (err) {
      debugger
      showAlert("danger", "No fue posible marca el paquete como Entregado.")
    } finally {
      setIsLoading(false)
      toogleModal()
    }
  }

  const onPackageSave = () => {
    reloadView();
  }

  return (
    <>
      <Row>
        <Col sm={{
          offset: 3,
          size: 5
        }} className="mt-3">
          {poBoxId && (<POBoxDetails poBoxId={poBoxId} />)}
        </Col>
      </Row>
      <Heading headingLevel="h2" className="pt-4" label="Lista de Paquetes" sticky >
        <Col sm={2}>
          <PackageAdviseNoticeOffCanvas
            className="float-end"
            btnColor="primary"
            poBox={poBox}
            onSave={onPackageSave}>
            Crear Prealerta
          </PackageAdviseNoticeOffCanvas>
        </Col>
      </Heading>
      <Container>
        <Row>
          <Col>
            <DynamicForm
              id="search"
              formConfig={getSearchForm()}
              onInputChange={(fieldName, v) => typeAHeadSearch(v)}>
            </DynamicForm>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table hover>
              <thead>
                <tr>
                  <th>
                    #
                  </th>
                  <th>
                    Warehouse
                  </th>
                  <th>
                    Cliente
                  </th>
                  <th>
                    Fecha Ingreso
                  </th>
                  <th>
                    # Carga
                  </th>
                  <th>
                    Estado
                  </th>
                  <th>
                    Costo
                  </th>
                  <th width="2%"></th>
                </tr>
              </thead>
              <LoadingTBody aheadLoading extraColumns={false} isLoading={showLoading}>
                {renderList()}
                {
                  boxesList.length == 0 && !showLoading && (
                    <tr>
                      <td colSpan="20">
                        <b>
                          No existe ningun paquete para el casillero seleccionado
                        </b>
                      </td>
                    </tr>
                  )
                }
                <tr>
                  <td colSpan="20">
                    <div ref={bottomRef} style={{ height: 1 }} />
                  </td>
                </tr>
              </LoadingTBody>
            </Table>
            {toUpdateBox && toUpdateBox.id && isDeleteConfirmVisible && (
              <DeleteModal
                title="Eliminar Paquete"
                toogle={toogleModal}
                isOpen={isModalOpen}
                onDelete={() => { deleteBox(toUpdateBox) }}>
                Esta seguro que desea eliminar el paquete #{toUpdateBox.secuencia}?
              </DeleteModal>
            )}
            {toUpdateBox && toUpdateBox.id && isDeliveryConfirmVisible && (
              <ConfirmModal
                toggle={toogleModal}
                isOpen={isModalOpen}
                title="Confirma Entrega"
                onConfirm={onDeliveryConfirmed}
                primaryBtn="Entregar"
              >
                Esta seguro que desea marcar este paquete como entregado?
              </ConfirmModal>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PackagesByPoBox;
